<template>
  <div class="invite-record">
    <pageHeader title="邀请记录" />

    <div class="invite-record-table" v-if="inviteList.length">
      <div class="table-thead">
        <div class="thead-th">
          <span>时间</span>
          <span class="block-box"></span>
        </div>
        <div class="thead-th">
          <span>好友</span>
          <span class="block-box"></span>
        </div>
      </div>
      <div class="table-tbody">
        <div class="tbody-td" v-for="(item, i) in inviteList" :key="i">
            <span>{{item.inviteDate}}</span>
            <span>{{item.invitePhone}}</span>
        </div>
      </div>
    </div>

    <div class="empty" v-else>
      <img classs="empty-img" src="@/assets/images/ic_default_three.png" alt="">
    </div>
  </div>
</template>

<script>
import pageHeader from "@/components/PageHeader";
import { requestMethods } from "@m/api";
import { mapGetters } from "vuex";
export default {
  components: {
    pageHeader,
  },
  computed: {
    ...mapGetters(["uuid"]),
  },
  data() {
    return {
      currentPage: 1,
      pageSize: 999,
      inviteList: []
    }
  },
  mounted() {
    this.fetchInviteUserList()
  },
  methods: {
    /**
     * 获取邀请记录
     */
    async fetchInviteUserList() {
      try {
        const { data } = await requestMethods(
          "/modules/user/user/fetchInviteUserList.htm",
          "post",
          {
            uuid: this.uuid,
            appType: 'WM',
            currentPage: this.currentPage,
            pageSize: this.pageSize
          }
        );
        this.inviteList = data || []
      } catch (err) {
        this.$toast(err.message)
      }
    },
  }
};
</script>

<style lang="scss" scoped>
.invite-record {
    background: #ffffff;
    min-height:100vh;
  .invite-record-table {
    background: #FFF;
    margin-top: 20px;
    .table-thead {
      display: flex;
      justify-content: space-between;
      height: 80px;
      width: 700px;
      margin: 0 25px;

      .thead-th {
        width: 350px;
        padding: 20px 123px;
        border-bottom: 1px solid #F2F2F2;
        text-align: center;
      }

      span {
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 28px;
        color: #333333;
        line-height: 40px;
        display: block;
      }
      .block-box {
        width: 80px;
        height: 12px;
        background: linear-gradient(
          270deg,
          rgba(255, 255, 255, 0) 0%,
          #ffbead 100%
        );
        margin-top: -10px;
        margin-left: 14px;
      }
    }
    .table-tbody {
        padding: 0 25px;
        .tbody-td {
            display: flex;
            height: 80px;
            text-align: center;
            border-bottom: 1px solid #F2F2F2;

            span {
                display: block;
                width: 50%;
                line-height: 80px;
            }
        }
    }
  }

  .empty {
    text-align: center;
    margin-top: 50%;
    empty-img {
      
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/inviteRecord/index.vue